import { Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import { Link } from 'src/components/Link';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { useOptionalSession } from 'src/contexts/SessionContext';
import { FeatureFlag } from 'src/models/platform/_types';
import { hasFeatureFlag } from 'src/shared/usePermissionCheck';

export const SiteFooter: React.FC = () => {
  const { session } = useOptionalSession();
  const currentYear = new Date().getFullYear();
  const hideWatermark = session
    ? hasFeatureFlag(session, FeatureFlag.HideWatermark)
    : false;
  const { t } = useTranslation('translation', { keyPrefix: 'footer' });

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        position: 'static',
        marginTop: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        zIndex: 5,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              &copy; {currentYear} {session?.brand} {t('all-rights-reserved')}
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mt: 1 }}
            >
              <Link component="a" href="/terms-of-service" variant="body2">
                {t('terms-of-service')}
              </Link>

              {!hideWatermark && (
                <>
                  <Typography variant="body2" color="text.secondary">
                    {t('separator')}
                  </Typography>
                  <Link
                    component="a"
                    href="https://Exercise.com"
                    target="_blank"
                    variant="body2"
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <img
                      src="https://res.cloudinary.com/brandpad/image/upload/c_scale,dpr_auto,f_auto,w_1536/v1/13578/colorblack-fill"
                      alt={t('exercise-logo-alt')}
                      style={{ height: '16px', marginRight: '4px' }}
                    />
                    {t('exercise-link-text')}
                  </Link>
                </>
              )}
            </Stack>
          </Grid>

          {(session?.iosDownloadLink || session?.androidDownloadLink) && (
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
              sx={{
                display: 'flex',
                justifyContent: {
                  xs: 'flex-start',
                  md: 'flex-end',
                },
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                {session?.iosDownloadLink && (
                  <Link component="a" href={session.iosDownloadLink}>
                    <img
                      src="https://cdn.exercise.com/assets/exercisecom/app-store-image.svg"
                      alt={t('download-ios', { brand: session.brand })}
                      style={{ height: '40px' }}
                    />
                  </Link>
                )}
                {session?.androidDownloadLink && (
                  <Link component="a" href={session.androidDownloadLink}>
                    <img
                      src="https://cdn.exercise.com/assets/exercisecom/play_store.png"
                      alt={t('download-android', { brand: session.brand })}
                      style={{ height: '40px' }}
                    />
                  </Link>
                )}
              </Stack>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};
